<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div class="ml-12 pa-0 white mt-6">
    <productFilterOptimsed_v2
      selector_type="products"
      class="pt-0 mt-0 pb-0 mb-0"
      v-bind:visible="$store.state.tradeDSM.productsOpen"
    ></productFilterOptimsed_v2>
    <productFilterOptimsed_v2
      selector_type="markets"
      class="pt-0 mt-0 pb-0 mb-0"
      v-bind:visible="$store.state.tradeDSM.countriesOpen"
    ></productFilterOptimsed_v2>
    <main-filters
      v-bind:filters="$store.getters.dsmFilterSettings.Filters"
      v-bind:visible="$store.state.tradeDSM.mainFilterOpen"
    ></main-filters>
    <advanced-filters
      v-bind:visible="$store.state.tradeDSM.advancedFilterOpen"
    ></advanced-filters>

    <trade-left-side-bar />

    <!--    <v-content>-->
    <v-container v-if="true" class="ml-1 pt-1 mt-0" fluid>
      <!--          ABOVE THIS-->
      <v-progress-linear
        v-if="loading"
        color="green lighten-3"
        indeterminate
      ></v-progress-linear>

      <v-container fluid class="pa-0 pr-1 ">
        <v-row class="pa-0 ma-0">
          <v-col sm="12" class="ma-0 pa-0">
            <trade-filters-top class="outline_top pt-0 pb-0 pl-1 pr-3" />
          </v-col>
        </v-row>
      </v-container>

      <trade-results-page class="ma-0 pa-0 ml-1  white" />

      <!--          BELOW THIS-->
    </v-container>
    <v-container v-else fill-height fluid>
      <v-layout class="justify-center align-center" row>
        <v-flex class="align-center justify-center sm-12">
          <span class="text-center">
            <h1>
              Loading....
            </h1>
          </span>
        </v-flex>
      </v-layout>
    </v-container>
    <!--    </v-content>-->
  </div>
</template>

<script>
import tradeLeftSideBar from '@/components/trade-dsm-application/left-side-bar/trade-left-side-bar';
import tradeFiltersTop from '@/components/trade-dsm-application/trade-filters-top.vue';
import tradeResultsPage from '@/components/trade-dsm-application/results-pages/trade-results-page.vue';
import productFilterOptimsed_v2 from '@/components/trade-dsm-application/left-side-bar/products/product-filter-optimsed_v2.vue';
import mainFilters from '@/components/trade-dsm-application/left-side-bar/filter_componenets/main-filters';
import advancedFilters from '@/components/trade-dsm-application/left-side-bar/filter_componenets/advanced-filters';

import progressMessageMixin from '@/components/trade-dsm-application/mixins/progress-message';

export default {
  name: 'tradeDsmApplication',
  mixins: [progressMessageMixin],
  components: {
    tradeLeftSideBar,
    tradeFiltersTop,
    tradeResultsPage,
    productFilterOptimsed_v2,
    mainFilters,
    advancedFilters,
  },

  mounted() {
    this.build_hs6_desc_hasgmap();
  },

  data: () => ({
    baseUrl: '',
    dsm_avg_result: null,
    messages: 2,
  }), //data
  computed: {
    loading() {
      return this.$store.state.tradeDSM.loading_indicator;
    },
  },
  watch: {
    loading() {
      // console.log(o, n);
    },
  },
};
</script>
